import React from "react";
import { DataGrid, GridToolbar } from "@mui/x-data-grid";
import { useEffect } from "react";
import Box from "@mui/material/Box";
import Grid from "@mui/material/Grid";
import CloseIcon from "@mui/icons-material/Close";
import moment from "moment";
import "./ReuseableComponent.css";
import { fDummyFunction, GridDataColumn } from "./Action";
import { CmpButton, CmpDatePickerFieldSearch } from "../ToolBox/ToolBox.js";
import Modal from "@mui/material/Modal";
import GCTitleSticky from "./GCTitleSticky.jsx";
const GCLoadingListSearch = ({
  open,
  xStatusArr = [],
  xLocationArr = [],
  xGetSearchValue = () => {},
  fonChangeStatusModal = () => {},
  fonChangeVocNoModal = () => {},
  fOnChangeDateModel = () => {},
  fonChangeLocModal = () => {},
  fonChangeRefNoModal = () => {},
  fCloseSearchModal = () => {},
  fClearSearchModal = () => {},
  GridSearchHeadRowData = [],
  GridDataColumnsSearch = [],
  xOnCellKeyDownSearch,
  xOnRowClickSearch,
  vMediaQuery = false,
  xEnterObj = "",
  xTitle = "",
  xStatusVal = "",
  xVocNoVal = "",
  xPostDtVal = new Date(),
  xLocVal = "",
  xRefNoVal = "",
}) => {
  const fCheckKey = (event) => {
    if (event.keyCode === 40) {
      var selectedLength =
        document.getElementsByClassName("Mui-selected").length;
      if (selectedLength === 0) {
        let tabel = document.getElementById("table-main-grid-4");
        // tabel?.getElementsByClassName("MuiDataGrid-row")[0].firstChild?.click();
        tabel?.getElementsByClassName("MuiDataGrid-row")[0].firstChild?.focus();
      }
    }
  };
  useEffect(() => {
    setTimeout(() => {
      document.onkeydown = fCheckKey;
    }, 1000);
  }, []);

  return (
    <Modal
      open={open}
      onClose={fCloseSearchModal}
      aria-labelledby="modal-modal-title"
      aria-describedby="modal-modal-description"
    >
      <div className="container-fluid">
        <Box sx={{ overflow: "auto" }} className="model-GCStockTransfer">
          <GCTitleSticky title={xTitle} onClose={fCloseSearchModal} />

          <div className="p-2">
            <Grid container spacing={1} columns={{ xs: 12, sm: 8, md: 12 }}>
              <Grid
                item
                xs={12}
                sm={12}
                md={4}
                className="gnr-item-search-label"
              >
                <Grid
                  container
                  spacing={1}
                  columns={{ xs: 12, sm: 12, md: 12 }}
                >
                  <Grid
                    item
                    xs={3}
                    sm={3}
                    md={2}
                    className="gnr-item-search-label"
                  >
                    Status
                  </Grid>
                  <Grid
                    item
                    xs={9}
                    sm={9}
                    md={10}
                    className="gnr-item-search-label"
                  >
                    <select
                      className="form-select form-select-sm"
                      name="Status"
                      value={xStatusVal}
                      onKeyUp={
                        !!xGetSearchValue
                          ? (e) => {
                              xGetSearchValue(e);
                            }
                          : fDummyFunction
                      }
                      onChange={
                        !!fonChangeStatusModal
                          ? (e) => {
                              fonChangeStatusModal(e, xStatusArr);
                            }
                          : fDummyFunction
                      }
                    >
                      {xStatusArr.length > 0 ? (
                        <>
                          {" "}
                          {xStatusArr?.map((value, index) => (
                            <option
                              className="py-2"
                              value={value}
                              key={"WmsStatus" + index}
                            >
                              {value}
                            </option>
                          ))}{" "}
                        </>
                      ) : (
                        <option value="">none</option>
                      )}
                    </select>
                  </Grid>
                </Grid>
              </Grid>
              <Grid
                item
                xs={12}
                sm={12}
                md={4}
                className="gnr-item-search-label"
              >
                <Grid
                  container
                  spacing={1}
                  columns={{ xs: 12, sm: 12, md: 12 }}
                >
                  <Grid
                    item
                    xs={3}
                    sm={3}
                    md={3}
                    className="gnr-item-search-label"
                  >
                    Voc.No
                  </Grid>
                  <Grid
                    item
                    xs={9}
                    sm={9}
                    md={9}
                    className="gnr-item-search-label"
                  >
                    <input
                      autoComplete="off"
                      className="form-control form-control-sm"
                      type="text"
                      name="VocNo"
                      value={xVocNoVal}
                      onKeyUp={
                        !!xGetSearchValue
                          ? (e) => {
                              xGetSearchValue(e);
                            }
                          : fDummyFunction
                      }
                      onChange={
                        !!fonChangeVocNoModal
                          ? (e) => {
                              fonChangeVocNoModal(e);
                            }
                          : fDummyFunction
                      }
                    />
                  </Grid>
                </Grid>
              </Grid>
              <Grid
                item
                xs={12}
                sm={12}
                md={4}
                className="gnr-item-search-label"
              >
                <Grid
                  container
                  spacing={1}
                  columns={{ xs: 12, sm: 12, md: 12 }}
                >
                  {" "}
                  <Grid item xs={3} className="gnr-item-search-label">
                    Voc.Dt
                  </Grid>
                  <Grid item xs={9} className="gnr-item-search-label">
                    {/* <input
                    className="form-control form-control-sm"
                    type="date"
                    name="PostDt"
                    value={moment(xPostDtVal).format("YYYY-MM-DD")}
                    onKeyUp={
                      !!xGetSearchValue
                        ? (e) => {
                            xGetSearchValue(e);
                          }
                        : fDummyFunction
                    }
                    onChange={
                      !!fOnChangeDateModel
                        ? (e) => {
                            fOnChangeDateModel(e);
                          }
                        : fDummyFunction
                    }
                  /> */}
                    <CmpDatePickerFieldSearch
                      xtabIndex={"2"}
                      xValue={xPostDtVal}
                      xOnChange={
                        !!fOnChangeDateModel
                          ? (e) => {
                              fOnChangeDateModel(e);
                            }
                          : fDummyFunction
                      }
                      xName={"PostDt"}
                      xError={false}
                      xErrorMessage={""}
                      xOnKeyUp={
                        !!xGetSearchValue
                          ? (e) => {
                              xGetSearchValue(e);
                            }
                          : fDummyFunction
                      }
                    />
                  </Grid>
                </Grid>
              </Grid>
              <Grid
                item
                xs={12}
                sm={12}
                md={4}
                className="gnr-item-search-label"
              >
                <Grid
                  container
                  spacing={1}
                  columns={{ xs: 12, sm: 12, md: 12 }}
                >
                  <Grid
                    item
                    xs={3}
                    sm={3}
                    md={2}
                    className="gnr-item-search-label"
                  >
                    Location
                  </Grid>
                  <Grid
                    item
                    xs={9}
                    sm={9}
                    md={10}
                    className="gnr-item-search-label"
                  >
                    <select
                      className="form-select form-select-sm"
                      name="Loc"
                      value={xLocVal}
                      onKeyUp={
                        !!xGetSearchValue
                          ? (e) => {
                              xGetSearchValue(e);
                            }
                          : fDummyFunction
                      }
                      onChange={
                        !!fonChangeLocModal
                          ? (e) => {
                              fonChangeLocModal(e, xLocationArr);
                            }
                          : fDummyFunction
                      }
                    >
                      {xLocationArr?.length > 0 ? (
                        <>
                        
                          {xLocationArr?.map((option, index) => (
                            <option
                              className="py-2"
                              value={option[Object.keys(option)[0]]}
                              key={"Location" + index}
                            >
                              {option[Object.keys(option)[1]]}
                            </option>
                          ))}
                        </>
                      ) : (
                        <option value="">none</option>
                      )}
                    </select>
                  </Grid>
                </Grid>
              </Grid>
              <Grid
                item
                xs={12}
                sm={12}
                md={4}
                className="gnr-item-search-label"
              >
                <Grid
                  container
                  spacing={1}
                  columns={{ xs: 12, sm: 12, md: 12 }}
                >
                  <Grid item xs={3} className="gnr-item-search-label">
                    Ref.No
                  </Grid>
                  <Grid item xs={9} className="gnr-item-search-label">
                    <input
                      autoComplete="off"
                      className="form-control form-control-sm"
                      type="text"
                      name="RefNo"
                      value={xRefNoVal}
                      onKeyUp={
                        !!xGetSearchValue
                          ? (e) => {
                              xGetSearchValue(e);
                            }
                          : fDummyFunction
                      }
                      onChange={
                        !!fonChangeRefNoModal
                          ? (e) => {
                              fonChangeRefNoModal(e);
                            }
                          : fDummyFunction
                      }
                    />
                  </Grid>
                </Grid>
              </Grid>
              <Grid
                item
                xs={12}
                sm={4}
                md={4}
                className="gnr-item-search-label align-self-center"
              >
                <Grid
                  container
                  spacing={0}
                  columns={{ xs: 12, sm: 12, md: 12 }}
                  className={"justify-content-end"}
                >
                  {vMediaQuery ? (
                    <Grid
                      item
                      xs={4}
                      sm={4}
                      md={4}
                      className="gnr-item-search-label mt-2"
                    >
                      
                      <CmpButton
                      xbtnName="Load"
                      xOnClick={(e) => {
                        xGetSearchValue(xEnterObj)
                      }
                    }
                      xVariant="contained"
                      xDisabled={false}
                      xSize="small"
                      // xSendIcon={<RemoveRedEyeIcon />}
                    />
                    </Grid>
                  ) : (
                    ""
                  )}
                  <Grid
                    item
                    xs={4}
                    sm={4}
                    md={4}
                    className="gnr-item-search-label mt-2"
                  >
                    {/* <button
                    
                      className="btn btn-primary  search-btn"
                      onClick={
                        !!fClearSearchModal
                          ? (e) => {
                              fClearSearchModal(e);
                            }
                          : fDummyFunction
                      }
                    >
                      Clear
                    </button> */}
                    <CmpButton
                      xbtnName="Clear"
                      xOnClick={(e) => {
                        fClearSearchModal(e);
                      }}
                      xVariant="contained"
                      xDisabled={false}
                      xSize="small"
                      // xSendIcon={<RemoveRedEyeIcon />}
                    />
                  </Grid>
                  <Grid
                    item
                    xs={4}
                    sm={4}
                    md={4}
                    className="gnr-item-search-label mt-2"
                  >
                    <CmpButton
                      xbtnName="Cancel"
                      xOnClick={(e) => {
                        fCloseSearchModal(e);
                        fClearSearchModal(e);
                      }}
                      xVariant="contained"
                      xDisabled={false}
                      xSize="small"
                      // xSendIcon={<RemoveRedEyeIcon />}
                    />
                    {/* <button
                      className="btn btn-primary  search-btn"
                      onClick={
                        !!fCloseSearchModal
                          ? (e) => {
                              fCloseSearchModal(e);
                              fClearSearchModal(e);
                            }
                          : fDummyFunction
                      }
                    >
                      Cancel
                    </button> */}
                  </Grid>
                </Grid>
              </Grid>
            </Grid>

            <Grid container spacing={1} columns={{ xs: 4, sm: 4, md: 12 }}>
              <Grid item xs={12} className="gnr-item-search-label mt-2">
                <div
                  style={{
                    height: vMediaQuery ? "43vh" : "58vh",
                    width: "100%",
                  }}
                  id="table-main-grid-4"
                >
                  <DataGrid
                    rowHeight={30}
                    headerHeight={40}
                    getRowClassName={(params) =>
                      params.indexRelativeToCurrentPage % 2 === 0
                        ? "mui-even-row"
                        : "mui-odd-row"
                    }
                    sx={{
                      border: 1,
                      borderColor: "primary.light",
                    }}
                    rows={GridSearchHeadRowData}
                    columns={
                      GridDataColumnsSearch
                        ? GridDataColumnsSearch
                        : GridDataColumn
                    }
                    onCellKeyDown={xOnCellKeyDownSearch}
                    onRowClick={xOnRowClickSearch}
                    hideFooter={GridSearchHeadRowData.length < 100}
                    // components={{
                    //   Toolbar: GridToolbar,
                    // }}
                  />
                </div>
              </Grid>
            </Grid>
          </div>
        </Box>
      </div>
    </Modal>
  );
};

export default GCLoadingListSearch;
